import React from "react";
import "./Modal.css";

const Modal = ({
  isOpen,
  onClose,
  height,
  width,
  backgroundColor,
  borderRadius,
  boxShadow,
  marginTop,
  closeButtonTop,
  closeButtonStyle,
  /** When true, close button sits in normal flow above the panel (responsive; avoids calc(50% - Npx) hacks). */
  closeAboveModal,
  /** Optional class on the stacked wrapper (e.g. width constraints that use % of overlay, not 100vw). */
  stackClassName,
  children,
  ...rest
}) => {
  if (!isOpen) return null;

  const modalStyle = {
    height: height || "23.625rem",
    width: width || "38rem",
    backgroundColor: backgroundColor || "#fff",
    borderRadius: borderRadius || "0.75rem",
    boxShadow: boxShadow || "0 0.25rem 0.375rem rgba(0, 0, 0, 0.1)",
    marginTop: marginTop || "2.5rem",
    ...rest,
  };

  const modalPanel = (
    <div className="modal-container" style={modalStyle}>
      {children}
    </div>
  );

  return (
    <div
      className="modal-overlay"
      style={{ "--modal-close-top": closeButtonTop || "15%" }}
    >
      {closeAboveModal ? (
        <div
          className={["modal-dialog-stack", stackClassName].filter(Boolean).join(" ")}
        >
          <button
            type="button"
            className="modal-close modal-close--stacked"
            onClick={onClose}
            style={closeButtonStyle}
            aria-label="Close"
          >
            ✕
          </button>
          {modalPanel}
        </div>
      ) : (
        <>
          <button
            type="button"
            className="modal-close"
            onClick={onClose}
            style={closeButtonStyle}
            aria-label="Close"
          >
            ✕
          </button>
          {modalPanel}
        </>
      )}
    </div>
  );
};

export default Modal;